import { Splide } from "@splidejs/splide";
import '@splidejs/splide/css';
document.addEventListener('DOMContentLoaded', function () {
    var sliderBannerElement = document.querySelector('.abi-ourvalues-slide');
    if (sliderBannerElement) {
        var sliderBanner_1 = new Splide(sliderBannerElement, {
            type: 'slide',
            perPage: 1,
            pagination: true,
            mediaQuery: 'min',
            breakpoints: {
                1024: {},
                767: {
                    perPage: 1,
                    // some sort of remount option here?
                },
            }
        });
        sliderBanner_1.on('ready', function () {
            var sliderNavigation = document.querySelector('.abi-ourvalues-slide .splide__pagination');
            var slideMoveTo = document.querySelector('.abi-ourvalues .abi-ourvalues__data');
            if (slideMoveTo && sliderNavigation) {
                slideMoveTo === null || slideMoveTo === void 0 ? void 0 : slideMoveTo.appendChild(sliderNavigation);
            }
        });
        sliderBanner_1.mount();
        var buttonsActionsMoveSlide = document.querySelectorAll(".abi-ourvalues__data-items-item-actions-button");
        if (buttonsActionsMoveSlide) {
            buttonsActionsMoveSlide.forEach(function (button) {
                button.addEventListener('click', function (event) {
                    var slideIndex = event.target.getAttribute('data-slide');
                    slideIndex && sliderBanner_1.go(parseInt(slideIndex));
                });
            });
        }
    }
});
